import { render } from "./EventRankingWithFirebase.vue?vue&type=template&id=407734d3&scoped=true&ts=true&lang=pug"
import script from "./EventRankingWithFirebase.vue?vue&type=script&lang=ts"
export * from "./EventRankingWithFirebase.vue?vue&type=script&lang=ts"

import "./EventRankingWithFirebase.vue?vue&type=style&index=0&id=407734d3&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-407734d3"]])

export default __exports__